// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.navg{
  background: rgba(white, 0.4);
}

.astyle{
    padding: 8px;
    color: white;
    font-size: 10px;
   
}

.subnav{
    background: rgba(white, 0.4);
}

  .dropdown {
    display: inline-block;
    position: relative;
  }
  
  button{
    border:none;
    border-radius:5px;
    color: white;
    font-size: 11px;
    font-weight: 600;
   
    cursor:pointer;
    border: none;
    background-color: transparent;
  }
  
  
  .dropdown-options {
    display: none;
    position: absolute !important;
    overflow: auto;
    background-color:#fff;
    border-radius:5px;
    box-shadow: 0px 10px 10px 0px rgba(0,0,0,0.4);
    z-index: 5;
    width: 15rem;
  }
  
  .dropdown:hover .dropdown-options {
    display: block;
  }
  
  .dropdown-options a {
    display: block;
    color: #000000;
    padding: 5px; 
    text-decoration: none;
    padding:20px 40px;
  }
  
  .dropdown-options a:hover {
    color: #0a0a23;
    background-color: #ddd;
    border-radius:5px;
  }
  .img-fluid{
    max-width: 100%;
    height: auto;
    /* this need to change */
    padding-top: 6px;
    padding-left: 53px;
  }



  .dashclass{
    border:none;
    border-radius:5px;
    color: white;
    font-size: 23px;
    font-weight: bolder;
    padding:  1px 1rem 1px 1rem;
    cursor:pointer;
    border: none;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    background-color: transparent;
  }
  .astyle{
    text-decoration: none;
    font-size: 15px;
    font-weight: bold;
  }
  .tabsbutton{
    border: 1px solid transparent;
    border-radius: 4px 4px 0 0;
    color: black;
    font-size:unset
  }
  .tabsbutton:hover{
    background-color: #2d348e !important;
    color: white !important;
  }
  .icon {
    padding-left: 25px;
    background: url(https://softmategroup.com/assets/images/My_Dashboard/Search.png) no-repeat left;
    background-size: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2rem;
    width: 1rem;
  }
  .liststyle{
    border: none;
    padding: 0;
    padding-left: 1rem;
    font-size: 12px;
    font-weight: 700;
    background-color: #fff2e9;
  }`, "",{"version":3,"sources":["webpack://./src/Components/Users/homepage.css"],"names":[],"mappings":";AACA;EACE,4BAA4B;AAC9B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;;AAEnB;;AAEA;IACI,4BAA4B;AAChC;;EAEE;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,gBAAgB;;IAEhB,cAAc;IACd,YAAY;IACZ,6BAA6B;EAC/B;;;EAGA;IACE,aAAa;IACb,6BAA6B;IAC7B,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,6CAA6C;IAC7C,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;EACpB;;;;EAIA;IACE,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,YAAY;IACZ,wEAAwE;IACxE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;IACrB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,YAAY;IACZ;EACF;EACA;IACE,oCAAoC;IACpC,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,+FAA+F;IAC/F,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;EACb;EACA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B","sourcesContent":["\n.navg{\n  background: rgba(white, 0.4);\n}\n\n.astyle{\n    padding: 8px;\n    color: white;\n    font-size: 10px;\n   \n}\n\n.subnav{\n    background: rgba(white, 0.4);\n}\n\n  .dropdown {\n    display: inline-block;\n    position: relative;\n  }\n  \n  button{\n    border:none;\n    border-radius:5px;\n    color: white;\n    font-size: 11px;\n    font-weight: 600;\n   \n    cursor:pointer;\n    border: none;\n    background-color: transparent;\n  }\n  \n  \n  .dropdown-options {\n    display: none;\n    position: absolute !important;\n    overflow: auto;\n    background-color:#fff;\n    border-radius:5px;\n    box-shadow: 0px 10px 10px 0px rgba(0,0,0,0.4);\n    z-index: 5;\n    width: 15rem;\n  }\n  \n  .dropdown:hover .dropdown-options {\n    display: block;\n  }\n  \n  .dropdown-options a {\n    display: block;\n    color: #000000;\n    padding: 5px; \n    text-decoration: none;\n    padding:20px 40px;\n  }\n  \n  .dropdown-options a:hover {\n    color: #0a0a23;\n    background-color: #ddd;\n    border-radius:5px;\n  }\n  .img-fluid{\n    max-width: 100%;\n    height: auto;\n    /* this need to change */\n    padding-top: 6px;\n    padding-left: 53px;\n  }\n\n\n\n  .dashclass{\n    border:none;\n    border-radius:5px;\n    color: white;\n    font-size: 23px;\n    font-weight: bolder;\n    padding:  1px 1rem 1px 1rem;\n    cursor:pointer;\n    border: none;\n    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;\n    background-color: transparent;\n  }\n  .astyle{\n    text-decoration: none;\n    font-size: 15px;\n    font-weight: bold;\n  }\n  .tabsbutton{\n    border: 1px solid transparent;\n    border-radius: 4px 4px 0 0;\n    color: black;\n    font-size:unset\n  }\n  .tabsbutton:hover{\n    background-color: #2d348e !important;\n    color: white !important;\n  }\n  .icon {\n    padding-left: 25px;\n    background: url(https://softmategroup.com/assets/images/My_Dashboard/Search.png) no-repeat left;\n    background-size: 34px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 2rem;\n    width: 1rem;\n  }\n  .liststyle{\n    border: none;\n    padding: 0;\n    padding-left: 1rem;\n    font-size: 12px;\n    font-weight: 700;\n    background-color: #fff2e9;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
